/**
 * The sign-in screen's classes, matching the admin console's
 * (web/admin/src/components/features/auth/styles.ts) so the two portals'
 * sign-in forms look the same. Kept in one file so the three auth forms here
 * cannot drift from each other.
 */

/**
 * The `autofill:` classes undo the browser's autofill tint. Chrome paints its
 * own background on a field filled from saved suggestions - a grey-blue in
 * dark mode - and no `background-color` can override it. A huge inset shadow
 * in the field's own white paints over it instead, and the text fill colour is
 * pinned because Chrome recolours that too.
 */
export const FIELD =
  'h-[42px] rounded-[9px] border-[1.5px] px-[13px] text-[13px] md:text-[12px] bg-white autofill:shadow-[inset_0_0_0_1000px_#fff] autofill:[-webkit-text-fill-color:var(--color-neutral-900)] autofill:[caret-color:var(--color-neutral-900)]';

export const LABEL = 'text-xs font-semibold text-[#48536A]';

export const SUBMIT = 'h-11 w-full rounded-[9px] text-md font-semibold mt-4 hover:cursor-pointer';

export const TITLE = 'text-[21px] font-semibold tracking-[-0.3px] text-auth-heading';

export const SUBTITLE = 'mt-2 mb-6 text-[13px] leading-[1.6] text-muted-foreground';

export const LINK = 'text-xs font-medium text-brand-500 hover:underline hover:cursor-pointer';

export const FIELD_ERROR = 'text-[12px] text-destructive';

/** The line under the form, as the admin form's "Trouble signing in?" note. */
export const FOOTER = 'mt-4.5 border-t pt-4.5 text-xs leading-[1.6] text-muted-foreground';

/** The admin MFA step's "← Back to sign in". */
export const BACK_LINK =
  'text-xs font-medium text-muted-foreground hover:text-foreground hover:cursor-pointer';

/** The resend countdown under the code step. */
export const TIMER_LINE = 'text-center text-xs text-muted-foreground';
export const TIMER_VALUE = 'font-mono font-semibold text-primary';
